export default __webpack_public_path__ + "static/media/Bill.97f70f4d.svg";